export default {
  title: 'Asetukset',
  fields: {
    discount_type: {
      label: 'Alennustyyppi',
    },
  },
  buttons: {
    save: 'Tallenna',
    cancel: 'Peruuta',
  },
  toasts: {
    update_successful: 'Päivitys onnistui',
    updated_failed: 'Päivitys epäonnistui',
  },
};
